const MERCHANT_ID_KEY = 'sweetour_merchant_id'
const USER_INFO_KEY = 'sweetour_user_info'
const URL_MERCHANT_ID_KEY = 'sweetour_url_merchant_id'

export function getMerchantId() {
  const merchantId = localStorage.getItem(MERCHANT_ID_KEY)
  return merchantId && merchantId !== 'undefined' ? merchantId : null
}

export function setMerchantId(merchantId) {
  localStorage.setItem(MERCHANT_ID_KEY, merchantId)
}

export function getUrlMerchantId() {
  return localStorage.getItem(URL_MERCHANT_ID_KEY) || null
}

export function setUrlMerchantId(merchantId) {
  localStorage.setItem(URL_MERCHANT_ID_KEY, String(merchantId))
  localStorage.setItem(MERCHANT_ID_KEY, String(merchantId))
}

export function getUserInfo() {
  const info = localStorage.getItem(USER_INFO_KEY)
  return info ? JSON.parse(info) : null
}

export function setUserInfo(userInfo) {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}

export function clearStorage() {
  localStorage.removeItem(MERCHANT_ID_KEY)
  localStorage.removeItem(USER_INFO_KEY)
}
